import { IconProps } from "./types";
import React from "react";

export const EdgeLogoIcon = ({
  className,
  fill = "currentColor",
  width = 20,
  height = 20,
  style = {},
}: IconProps): React.ReactElement => (
  <svg
    width={width}
    height={height}
    style={style}
    className={className}
    viewBox="0 0 38 34"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs id="defs4"></defs>
    <g transform="scale(0.1892, 0.1892)">
      <path
        opacity="1"
        stroke="none"
        d="M 1.000001,154 C 1,103.07114 1,52.142284 1,1 c 53.354038,0 106.70836,0 160.44366,0.325514 -3.5043,3.884733 -7.46798,7.362639 -11.26027,11.018351 -11.57113,11.154439 -23.07643,22.377178 -34.60638,33.574336 -0.47684,0.463082 -0.93487,0.94574 -1.41675,1.403397 C 103.39813,57.542717 92.633888,67.761604 81.562515,78.10228 70.321022,88.49929 59.322289,98.707115 48.471066,109.0694 37.337456,119.70135 26.398266,130.53682 15.271519,141.17606 10.651258,145.5939 5.765193,149.73375 1.000001,154 Z"
        id="path1"
      ></path>
      <path
        fill={fill || "#004792"}
        opacity="1"
        stroke="none"
        d="m 1.000002,154.5 c 4.765191,-4.76625 9.651256,-8.9061 14.271517,-13.32394 11.126747,-10.63924 22.065937,-21.47471 33.199547,-32.10666 10.851223,-10.362285 21.849956,-20.57011 33.221302,-30.719707 0.735145,0.341362 1.032905,0.556687 1.320602,1.229943 -0.01006,24.639424 -0.01006,48.820904 -0.01006,73.892214 8.345405,-7.97927 15.877189,-15.17743 23.40533,-22.3794 7.78217,-7.44499 15.56099,-14.89347 23.34054,-22.34118 0.48047,-0.45999 0.94961,-0.93185 1.43227,-1.3895 9.93008,-9.415405 19.86137,-18.829543 30.16914,-28.284622 1.13443,-0.05283 1.89212,-0.06499 2.64981,-0.07715 0,25.613532 0,51.227072 0,77.000002 -53.83496,0 -107.670079,0.003 -161.505159,-0.0414 -0.49854,-4.1e-4 -0.996569,-0.62529 -1.494836,-1.45862 z"
        id="path2"
      ></path>
      <path
        fill={fill || "#008aff"}
        opacity="1"
        stroke="none"
        d="m 164,78.531342 c -0.75769,0.480812 -1.51538,0.492973 -3.11652,0.494781 -26.51579,0.02496 -52.18811,0.06027 -77.860447,0.09558 -0.29776,-0.215324 -0.59552,-0.430649 -1.02314,-0.893387 10.633995,-10.466713 21.398237,-20.6856 32.160367,-30.906719 0.48188,-0.457657 0.93991,-0.940315 1.41675,-1.403397 11.52995,-11.197158 23.03525,-22.419897 34.60638,-33.574336 3.79229,-3.655712 7.75597,-7.133618 11.72893,-11.018351 3.13498,-0.936455 2.05248,1.377753 2.05515,2.64705 0.0454,21.547385 0.0325,43.094891 0.0325,64.642373 0,3.149246 0,6.2985 0,9.916405 z"
        id="path3"
      ></path>
      <path
        opacity="1"
        stroke="none"
        d="m 83.01297,79.579636 c 25.6824,-0.493248 51.35472,-0.528557 77.49377,-0.512833 -9.46432,9.465424 -19.39561,18.879562 -29.32569,28.294967 -0.48266,0.45765 -0.9518,0.92951 -1.43227,1.3895 -7.77955,7.44771 -15.55837,14.89619 -23.34054,22.34118 -7.528144,7.20197 -15.059928,14.40013 -23.405333,22.3794 0,-25.07131 0,-49.25279 0.01006,-73.892214 z"
        id="path4"
      ></path>
    </g>
  </svg>
);
